import { Button } from "@chakra-ui/react";
import { type ReactNode } from "react";
import { FiChevronRight } from "react-icons/fi";
import { FocusOverlay } from "../../../common/focus/FocusOverlay";
import { FocusSubjectList } from "../../../common/focus/FocusSubjectList";
import type { FocusProgress, FocusSubject } from "../../../common/focus/focusSubject";
import { useBidSubjectTerms } from "../../../common/terminology/bidSubjectTerms";

interface Props {
  eyebrow: string;
  subtitle?: string;
  subjects: FocusSubject[];
  active: FocusSubject;
  index: number;
  progress: FocusProgress;
  hasPrevious: boolean;
  hasNext: boolean;
  onSelect: (id: string) => void;
  onPrevious: () => void;
  onNext: () => void;
  onClose: () => void;
  renderContent: (subject: FocusSubject) => ReactNode;
  renderActions: (subject: FocusSubject) => ReactNode;
}

export const BidFocusOverlay = ({
  eyebrow,
  subtitle,
  subjects,
  active,
  index,
  progress,
  hasPrevious,
  hasNext,
  onSelect,
  onPrevious,
  onNext,
  onClose,
  renderContent,
  renderActions,
}: Props) => {
  const terms = useBidSubjectTerms();

  return (
    <FocusOverlay
      eyebrow={eyebrow}
      title={active.title}
      subtitle={subtitle}
      position={{ current: index + 1, total: subjects.length }}
      onPrevious={onPrevious}
      onNext={onNext}
      hasPrevious={hasPrevious}
      hasNext={hasNext}
      previousLabel={terms.previous}
      nextLabel={terms.next}
      onClose={onClose}
      scrollResetKey={active.id}
      listPanel={
        <FocusSubjectList
          heading={terms.subjects}
          subjects={subjects}
          activeId={active.id}
          onSelect={onSelect}
          progress={progress}
        />
      }
      footerStart={renderActions(active)}
      footerEnd={
        <Button rightIcon={<FiChevronRight />} onClick={onNext} isDisabled={!hasNext}>
          {terms.next}
        </Button>
      }
    >
      {renderContent(active)}
    </FocusOverlay>
  );
};
